import { PublicUserModel, UserModel } from '../models';

export const getFriendlyName = (user: UserModel | undefined): string | undefined => {
   if (!user) return undefined;

   return user?.username || user?.fullname?.split(' ')[0] || user?.publicKey?.substring(0, 5) || '';
};

export const getFriendlyPublicName = (user: PublicUserModel): string | undefined => {
   return user.username || user.fullname || user.publicKey?.substring(0, 5) || 'Unknown';
};

export const getFriendlyPublicKey = (user: UserModel | undefined, short: boolean = false): string | undefined => {
   if (!user?.primaryWallet?.publicKey) return undefined;
   if (short) return user.primaryWallet.publicKey.substring(0, 5);
   return user.primaryWallet.publicKey.substring(0, 4) + '...' + user.primaryWallet.publicKey.substring(user.primaryWallet.publicKey.length - 4);
};
